import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import { useAuth } from '../auth/auth.hook';
import { useConfig } from '../config/config.hook';
import { useToggles } from '../config/internal/toggles/toggles.hook';
import { ContextResult, CursoComplementar, Provider } from './cursos-complementares.types';
import { cursosComplementaresMapper } from './mappers/cursos-complementares/cursos-complementares.mapper';
import { consultarCursosComplementaresService } from './services/consultar-cursos-complementares/consultar-cursos-complementares.service';
import { Result } from './services/consultar-cursos-complementares/consultar-cursos-complementares.types';

export const CursosComplementaresContext = createContext<ContextResult | null>(null);

export const CursosComplementaresProvider: Provider = ({ children }) => {
  const estadoInicial: ContextResult = useMemo(() => {
    return { cursosComplementares: [], pendente: true, erro: false };
  }, []);

  const { isEnabled } = useToggles();
  const { getValueOrThrow } = useConfig();
  const { token } = useAuth();

  const urlBase = getValueOrThrow<string>('API_DEDICADA');

  const [asyncCursosComplementares, setAsyncCursosComplementares] = useState<{
    cursosComplementares: CursoComplementar[];
    erro: boolean;
    pendente: boolean;
  }>(estadoInicial);

  const reset = useCallback(() => {
    setAsyncCursosComplementares(estadoInicial);
  }, [estadoInicial]);

  const erro = useCallback(() => {
    setAsyncCursosComplementares({
      erro: true,
      pendente: false,
      cursosComplementares: [],
    });
  }, []);

  const sucesso = useCallback((cursosComplementares: CursoComplementar[]) => {
    setAsyncCursosComplementares({
      cursosComplementares,
      pendente: false,
      erro: false,
    });
  }, []);

  useEffect(() => {
    reset();

    if (isEnabled('SAVA_209845')) {
      consultarCursosComplementaresService({ urlBase, token })
        .then((cursosComplementaresApiResult: Result) =>
          sucesso(cursosComplementaresMapper(cursosComplementaresApiResult)),
        )
        .catch(() => erro());
    }
  }, [erro, reset, sucesso, token, urlBase, isEnabled]);

  return (
    <CursosComplementaresContext.Provider value={asyncCursosComplementares}>
      {children}
    </CursosComplementaresContext.Provider>
  );
};
